<template>
    <div class="recordList">
        <div v-if="planList.length">
            <PlanList
                :planList="planList"
                :userType="userType"
                :pageData="pageData"
            ></PlanList>
            <Pagination :pageData="pageData" @changePage="changeCurrent" v-show="pageData.total>pageData.pageSize"></Pagination>
        </div>
        <div v-else class="noContent">
            <NoContent></NoContent>
        </div>
    </div>
</template>
<script>
import Add from '@/components/consultant/Add'
import PlanList from '@/components/consultant/planningContent/PlanList.vue'
import Pagination from '@/components/consultant/Pagination.vue'
import NoContent from '@/components/NoContent.vue'
export default {
    name: "recordList",
    components: {
        Add,
        PlanList,
        Pagination,
        NoContent
    },
    data() {
        return {
            userType: 2,  //1学生，2家长 3咨询师
            planList:[],
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            pageData: {
                current:1,//当前页
                pageSize:10,//每页多少条
                totalPage:1,//总页数数
                total:1//总条数
            },
        }
    },
    created() {
        this.getPlanList();
    },
    methods: {
        changeCurrent(value) {
            this.pageData.current = value;
            this.getPlanList();
        },
        // 获取成绩列表
        getPlanList(){
            let pageData = this.pageData;
            this.$ajax.post(this.G_acapi + this.ports.parent.student.planningContent.getPlanListByParent, {
                pageSize: pageData.pageSize,
                pageNumber: pageData.current
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    let page = res.data.data.page;
                    this.planList = res.data.data.list;
                    this.pageData={
                        current:page.pageNumber,//当前页
                        pageSize:page.pageSize,//每页多少条
                        totalPage:page.count,//总页数数
                        total:page.count//总条数
                    };
                }else{

                }
            })
        },
    }
}
</script>
<style scoped lang="less">
.recordList {
    background-color: #fff;
    padding: 20px 25px;
    min-height: 600px;
}
</style>